import { useWatch } from '@kanda-libs/ks-component-ts';
import { useMemo } from 'react';

import { calculateFinanceCosts } from './helpers';

export interface CreditLineHook {
  creditLine: number;
  interest: string;
  fee: number;
  terms: string;
  monthly: number;
}

function useCreditCosts(): CreditLineHook {
  const [formFinanceOption, creditAmount] = useWatch({
    name: ['financeOption', 'credit.amount', 'deposit.amount'],
  });

  const interest: string = useMemo(() => {
    if (!formFinanceOption) return '11.9% APR';
    return `${formFinanceOption?.apr / 100}% APR`;
  }, [formFinanceOption]);

  const terms: string = useMemo(() => {
    if (!formFinanceOption) return '0';
    return String(formFinanceOption.duration);
  }, [formFinanceOption]);

  const costs = calculateFinanceCosts(formFinanceOption, creditAmount);

  return {
    creditLine: costs?.creditLine || 0,
    interest,
    fee: costs?.fee || 0,
    terms,
    monthly: costs?.monthly || 0,
  };
}

export default useCreditCosts;
